import {Time} from 'yougile-util'
import {
  JSONLike,
  SprintStickerState,
  StickerColor,
  StickerStateId,
  StickerType,
  Tag
} from 'yougile-model'
import {SprintCtl} from '@extensions/sticker/controllers/sprint-ctl'

export interface StickerState {
  id: StickerStateId
  name: string
  begin?: number
  end?: number
  color?: StickerColor
}

export const getStatesList = (sticker: Tag): StickerState[] => {
  const allKeys = Object.keys(sticker.states.index)
  const uniqueOrdered = new Set(sticker.states.order)
  const keys = [...uniqueOrdered, ...allKeys.filter(k => !uniqueOrdered.has(k))]

  return keys
    .map(id => sticker.states.index[id] as StickerState)
    .filter(s => !!s)
}

export const getStateColor = (
  state: JSONLike,
  stickerType: StickerType
): StickerColor => {
  if (stickerType === 'string') {
    return state?.color || 'sticker-gray'
  }

  const now = Time.now()
  if ((!state.begin && !state.end) || state.end < now) {
    return 'sticker-gray'
  }
  if (state.begin > now) {
    return 'sticker-blue'
  }
  return 'sticker-orange'
}

export const getStickerStateTitle = (
  stickerState: JSONLike,
  stickerType: StickerType,
  stickerTitle: string
): string => {
  if (!stickerState?.name) {
    return stickerTitle
  }

  if (stickerType === 'sprint') {
    return `${stickerState.name} ${
      stickerState.begin && stickerState.end
        ? SprintCtl.formatInterval(stickerState as SprintStickerState)
        : ''
    }`
  }
  return stickerState.name
}
